import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';
import type { MostRecentModel } from '@/common/interfaces/mostRecent.interface';

/** Defining a service using a base URL and expected endpoints  */
export const mostRecentApi = createApi({
  reducerPath: 'mostRecentApi',
  tagTypes: ['MostRecent'],
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (build) => ({
    getMostRecentActivity: build.query<MostRecentModel, void>({
      query: () => ({ url: `api/cp/most-recent`, method: 'get' }),
      providesTags: ['MostRecent'],
    }),
  }),
});

/** Export hooks for usage in functional components, which are auto-generated based on the defined endpoints */
export const { useGetMostRecentActivityQuery, useLazyGetMostRecentActivityQuery, util } =
  mostRecentApi;
